import { UpdateLicenseVersion, UpdateLicenseVersionApi } from '../../../../domainModels/licenceVersions/UpdateLicenseVersion';
import { PaymentStatus, mapPaymentStatusToApiModel } from '../../../../domainModels/licences/PaymentStatus';
import { dateToApiDateStringFormat } from '../../../../helpers/moment';

export const updateLicenseVersionModelToApi = (model: UpdateLicenseVersion): UpdateLicenseVersionApi => ({
    ...model,
    paymentDeadline: dateToApiDateStringFormat(model.paymentDeadline),
    validFrom: dateToApiDateStringFormat(model.validFrom),
    validTo: dateToApiDateStringFormat(model.validTo),
    paymentStatus: mapPaymentStatusToApiModel(model.paymentStatus) || PaymentStatus.Awaiting,
});
